export default "assets/jp-d48bd9d9.svg";